import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const projects = [
  {
    title: 'Onaliana',
    description: 'Luxury leather bags and premium tote bags designed for elegance and durability.',
    image: 'https://media-manager-c.questera.ai/greta-media/fafed1dc96bdeaff472e762fc9535f37237b73cd078ba929908d8fc9f91ee4faeb3717965c5074a04f18e80ee0d17e20/images/aW1hZ2UvanBlZw==/f019f9c0690a52380944a64dc8b99a2e.jpeg',
    link: 'https://onaliana.com',
    services: ['Website Design', 'Product Showcase', 'WhatsApp Ordering']
  },
  {
    title: 'FunkeCreamz',
    description: 'Bespoke cake artist and beadbag business providing custom creations for special events.',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=80&w=800&auto=format&fit=crop',
    link: null,
    services: ['Website Design', 'Lead Capture', 'WhatsApp Ordering']
  }
];

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">Portfolio</h2>
          <p className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">Recent Projects</p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 mx-auto font-medium">See how we've helped businesses transform their digital presence.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
              className="bg-white rounded-[2.5rem] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 flex flex-col group"
            >
              <div className="h-64 sm:h-80 overflow-hidden relative">
                <div className="absolute inset-0 bg-slate-900/10 group-hover:bg-transparent transition-colors duration-300 z-10" />
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8 md:p-10 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-slate-900 mb-3">{project.title}</h3>
                <p className="text-slate-600 mb-6 leading-relaxed font-medium">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-8">
                  {project.services.map(service => (
                    <span key={service} className="px-3 py-1 bg-emerald-50 text-emerald-700 text-xs font-bold rounded-full uppercase tracking-wider">
                      {service}
                    </span>
                  ))}
                </div>
                <div className="mt-auto pt-6 border-t border-slate-100">
                  {project.link ? (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-emerald-600 font-bold hover:text-emerald-700 transition-colors"
                    >
                      View Project <SafeIcon icon={FiExternalLink} className="ml-2" />
                    </a>
                  ) : (
                    <span className="inline-flex items-center px-3 py-1 bg-slate-100 text-slate-500 text-xs font-bold rounded-full uppercase tracking-wider">
                      Coming soon
                    </span>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
